"use strict";

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var io = require("socket.io-client");

var _require = require("rxjs"),
    Subject = _require.Subject,
    Observable = _require.Observable;

var request = require("superagent");
var ConnetionStatus = require("./ConnectionStatus");

var post = function post(path) {
  var reqCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (req) {
    return req;
  };
  return Observable.create(function (observer) {
    var req = request.post(path);

    reqCallback(req).end(function (err, res) {
      if (err) {
        observer.error(err);
      } else {
        observer.next(res.body);
        observer.complete();
      }
    });

    return function () {
      return req.abort();
    };
  });
};

var AmbitClient = function () {
  function AmbitClient(config) {
    (0, _classCallCheck3.default)(this, AmbitClient);

    this.config = config;

    var transports = this.config.usePolling ? ['polling'] : ['polling', 'websocket'];

    this.io = io(this.config.baseUrl + "/webchat", { transports: transports });

    this.connectionStatus$ = new Subject();
    this.activity$ = new Subject();

    this.io.on('botMessage', this.handleIncomingBotMessage.bind(this));
    this.io.on('connectionReady', this.handleConnectionReady.bind(this));
    this.io.on('connect', this.connectToConversation.bind(this));
    this.io.on('disconnect', this.handleDisconnect.bind(this));
  }

  (0, _createClass3.default)(AmbitClient, [{
    key: "getDirectLineConnectUrl",
    value: function getDirectLineConnectUrl() {
      var conversationId = this.conversationId || this.config.conversationId;

      return conversationId ? this.config.baseUrl + "/v3/directline/conversations/" + conversationId : this.config.baseUrl + "/v3/directline/conversations";
    }
  }, {
    key: "getDirectLinePostActivityUrl",
    value: function getDirectLinePostActivityUrl() {
      return this.config.baseUrl + "/v3/directline/conversations/" + this.conversationId + "/activities";
    }
  }, {
    key: "getDirectLineUploadUrl",
    value: function getDirectLineUploadUrl() {
      return this.config.baseUrl + "/v3/directline/conversations/" + this.conversationId + "/upload";
    }
  }, {
    key: "connectToConversation",
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var req;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return request.post(this.getDirectLineConnectUrl()).send(this.config.user || this.user).set("Authorization", "Bearer " + this.config.secret);

              case 2:
                req = _context.sent;


                this.user = this.config.user || req.body.user;
                this.conversationId = req.body.conversationId;
                this.conversationToken = req.body.conversationToken;

                this.io.emit("joinConversation", this.conversationToken);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function connectToConversation() {
        return _ref.apply(this, arguments);
      }

      return connectToConversation;
    }()
  }, {
    key: "handleIncomingBotMessage",
    value: function handleIncomingBotMessage(payload) {
      var _this = this;

      payload.activities.forEach(function (activity) {
        return _this.activity$.next(activity);
      });
    }
  }, {
    key: "handleConnectionReady",
    value: function handleConnectionReady() {
      this.connectionStatus$.next(ConnetionStatus.Online);
    }
  }, {
    key: "handleDisconnect",
    value: function handleDisconnect() {
      this.connectionStatus$.next(ConnetionStatus.Uninitialized);
    }
  }, {
    key: "postActivity",
    value: function postActivity(activity) {
      var _this2 = this;

      if (activity.type === 'message' && activity.file) {
        return this.postActivityWithAttachments(activity);
      }

      return post(this.getDirectLinePostActivityUrl(), function (req) {
        return req.send(activity).set("Authorization", "Bearer " + _this2.config.secret);
      }).map(function (response) {
        return response.id;
      });
    }
  }, {
    key: "postActivityWithAttachments",
    value: function postActivityWithAttachments(activity) {
      var _this3 = this;

      return post(this.getDirectLineUploadUrl(), function (req) {
        return req.attach('activity', new Blob([JSON.stringify(activity)])).attach('file', activity.file).set('Authorization', "Bearer " + _this3.config.secret);
      }).map(function (response) {
        return response.id;
      });
    }
  }]);
  return AmbitClient;
}();

module.exports = AmbitClient;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ambit-ai/ambit-client/lib/AmbitClient.js
// module id = 550
// module chunks = 0